{
  "amber": {
    "50": {
      "$type": "color",
      "$value": "#fffbeb"
    },
    "100": {
      "$type": "color",
      "$value": "#fef3c7"
    },
    "200": {
      "$type": "color",
      "$value": "#fde68a"
    },
    "300": {
      "$type": "color",
      "$value": "#fcd34d"
    },
    "400": {
      "$type": "color",
      "$value": "#fbbf24"
    },
    "500": {
      "$type": "color",
      "$value": "#f59e0b"
    },
    "600": {
      "$type": "color",
      "$value": "#d97706"
    },
    "700": {
      "$type": "color",
      "$value": "#b45309"
    },
    "800": {
      "$type": "color",
      "$value": "#92400e"
    },
    "900": {
      "$type": "color",
      "$value": "#78350f"
    },
    "950": {
      "$type": "color",
      "$value": "#451a03"
    }
  },
  "blue": {
    "50": {
      "$type": "color",
      "$value": "#eff6ff"
    },
    "100": {
      "$type": "color",
      "$value": "#dbeafe"
    },
    "200": {
      "$type": "color",
      "$value": "#bfdbfe"
    },
    "300": {
      "$type": "color",
      "$value": "#93c5fd"
    },
    "400": {
      "$type": "color",
      "$value": "#60a5fa"
    },
    "500": {
      "$type": "color",
      "$value": "#3b82f6"
    },
    "600": {
      "$type": "color",
      "$value": "#2563eb"
    },
    "700": {
      "$type": "color",
      "$value": "#1d4ed8"
    },
    "800": {
      "$type": "color",
      "$value": "#1e40af"
    },
    "900": {
      "$type": "color",
      "$value": "#1e3a8a"
    },
    "950": {
      "$type": "color",
      "$value": "#172554"
    }
  },
  "border": {
    "radius": {
      "none": {
        "$type": "number",
        "$value": 0
      },
      "xs": {
        "$type": "number",
        "$value": 2
      },
      "sm": {
        "$type": "number",
        "$value": 4
      },
      "md": {
        "$type": "number",
        "$value": 6
      },
      "lg": {
        "$type": "number",
        "$value": 8
      },
      "xl": {
        "$type": "number",
        "$value": 12
      }
    }
  },
  "cyan": {
    "50": {
      "$type": "color",
      "$value": "#ecfeff"
    },
    "100": {
      "$type": "color",
      "$value": "#cffafe"
    },
    "200": {
      "$type": "color",
      "$value": "#a5f3fc"
    },
    "300": {
      "$type": "color",
      "$value": "#67e8f9"
    },
    "400": {
      "$type": "color",
      "$value": "#22d3ee"
    },
    "500": {
      "$type": "color",
      "$value": "#06b6d4"
    },
    "600": {
      "$type": "color",
      "$value": "#0891b2"
    },
    "700": {
      "$type": "color",
      "$value": "#0e7490"
    },
    "800": {
      "$type": "color",
      "$value": "#155e75"
    },
    "900": {
      "$type": "color",
      "$value": "#164e63"
    },
    "950": {
      "$type": "color",
      "$value": "#083344"
    }
  },
  "emerald": {
    "50": {
      "$type": "color",
      "$value": "#ecfdf5"
    },
    "100": {
      "$type": "color",
      "$value": "#d1fae5"
    },
    "200": {
      "$type": "color",
      "$value": "#a7f3d0"
    },
    "300": {
      "$type": "color",
      "$value": "#6ee7b7"
    },
    "400": {
      "$type": "color",
      "$value": "#34d399"
    },
    "500": {
      "$type": "color",
      "$value": "#10b981"
    },
    "600": {
      "$type": "color",
      "$value": "#059669"
    },
    "700": {
      "$type": "color",
      "$value": "#047857"
    },
    "800": {
      "$type": "color",
      "$value": "#065f46"
    },
    "900": {
      "$type": "color",
      "$value": "#064e3b"
    },
    "950": {
      "$type": "color",
      "$value": "#022c22"
    }
  },
  "fuchsia": {
    "50": {
      "$type": "color",
      "$value": "#fdf4ff"
    },
    "100": {
      "$type": "color",
      "$value": "#fae8ff"
    },
    "200": {
      "$type": "color",
      "$value": "#f5d0fe"
    },
    "300": {
      "$type": "color",
      "$value": "#f0abfc"
    },
    "400": {
      "$type": "color",
      "$value": "#e879f9"
    },
    "500": {
      "$type": "color",
      "$value": "#d946ef"
    },
    "600": {
      "$type": "color",
      "$value": "#c026d3"
    },
    "700": {
      "$type": "color",
      "$value": "#a21caf"
    },
    "800": {
      "$type": "color",
      "$value": "#86198f"
    },
    "900": {
      "$type": "color",
      "$value": "#701a75"
    },
    "950": {
      "$type": "color",
      "$value": "#4a044e"
    }
  },
  "gray": {
    "50": {
      "$type": "color",
      "$value": "#f9fafb"
    },
    "100": {
      "$type": "color",
      "$value": "#f3f4f6"
    },
    "200": {
      "$type": "color",
      "$value": "#e5e7eb"
    },
    "300": {
      "$type": "color",
      "$value": "#d1d5db"
    },
    "400": {
      "$type": "color",
      "$value": "#9ca3af"
    },
    "500": {
      "$type": "color",
      "$value": "#6b7280"
    },
    "600": {
      "$type": "color",
      "$value": "#4b5563"
    },
    "700": {
      "$type": "color",
      "$value": "#374151"
    },
    "800": {
      "$type": "color",
      "$value": "#1f2937"
    },
    "900": {
      "$type": "color",
      "$value": "#111827"
    },
    "950": {
      "$type": "color",
      "$value": "#030712"
    }
  },
  "green": {
    "50": {
      "$type": "color",
      "$value": "#f0fdf4"
    },
    "100": {
      "$type": "color",
      "$value": "#dcfce7"
    },
    "200": {
      "$type": "color",
      "$value": "#bbf7d0"
    },
    "300": {
      "$type": "color",
      "$value": "#86efac"
    },
    "400": {
      "$type": "color",
      "$value": "#4ade80"
    },
    "500": {
      "$type": "color",
      "$value": "#22c55e"
    },
    "600": {
      "$type": "color",
      "$value": "#16a34a"
    },
    "700": {
      "$type": "color",
      "$value": "#15803d"
    },
    "800": {
      "$type": "color",
      "$value": "#166534"
    },
    "900": {
      "$type": "color",
      "$value": "#14532d"
    },
    "950": {
      "$type": "color",
      "$value": "#052e16"
    }
  },
  "indigo": {
    "50": {
      "$type": "color",
      "$value": "#eef2ff"
    },
    "100": {
      "$type": "color",
      "$value": "#e0e7ff"
    },
    "200": {
      "$type": "color",
      "$value": "#c7d2fe"
    },
    "300": {
      "$type": "color",
      "$value": "#a5b4fc"
    },
    "400": {
      "$type": "color",
      "$value": "#818cf8"
    },
    "500": {
      "$type": "color",
      "$value": "#6366f1"
    },
    "600": {
      "$type": "color",
      "$value": "#4f46e5"
    },
    "700": {
      "$type": "color",
      "$value": "#4338ca"
    },
    "800": {
      "$type": "color",
      "$value": "#3730a3"
    },
    "900": {
      "$type": "color",
      "$value": "#312e81"
    },
    "950": {
      "$type": "color",
      "$value": "#1e1b4b"
    }
  },
  "lime": {
    "50": {
      "$type": "color",
      "$value": "#f7fee7"
    },
    "100": {
      "$type": "color",
      "$value": "#ecfccb"
    },
    "200": {
      "$type": "color",
      "$value": "#d9f99d"
    },
    "300": {
      "$type": "color",
      "$value": "#bef264"
    },
    "400": {
      "$type": "color",
      "$value": "#a3e635"
    },
    "500": {
      "$type": "color",
      "$value": "#84cc16"
    },
    "600": {
      "$type": "color",
      "$value": "#65a30d"
    },
    "700": {
      "$type": "color",
      "$value": "#4d7c0f"
    },
    "800": {
      "$type": "color",
      "$value": "#3f6212"
    },
    "900": {
      "$type": "color",
      "$value": "#365314"
    },
    "950": {
      "$type": "color",
      "$value": "#1a2e05"
    }
  },
  "neutral": {
    "50": {
      "$type": "color",
      "$value": "#fafafa"
    },
    "100": {
      "$type": "color",
      "$value": "#f5f5f5"
    },
    "200": {
      "$type": "color",
      "$value": "#e5e5e5"
    },
    "300": {
      "$type": "color",
      "$value": "#d4d4d4"
    },
    "400": {
      "$type": "color",
      "$value": "#a3a3a3"
    },
    "500": {
      "$type": "color",
      "$value": "#737373"
    },
    "600": {
      "$type": "color",
      "$value": "#525252"
    },
    "700": {
      "$type": "color",
      "$value": "#404040"
    },
    "800": {
      "$type": "color",
      "$value": "#262626"
    },
    "900": {
      "$type": "color",
      "$value": "#171717"
    },
    "950": {
      "$type": "color",
      "$value": "#0a0a0a"
    }
  },
  "orange": {
    "50": {
      "$type": "color",
      "$value": "#fff7ed"
    },
    "100": {
      "$type": "color",
      "$value": "#ffedd5"
    },
    "200": {
      "$type": "color",
      "$value": "#fed7aa"
    },
    "300": {
      "$type": "color",
      "$value": "#fdba74"
    },
    "400": {
      "$type": "color",
      "$value": "#fb923c"
    },
    "500": {
      "$type": "color",
      "$value": "#f97316"
    },
    "600": {
      "$type": "color",
      "$value": "#ea580c"
    },
    "700": {
      "$type": "color",
      "$value": "#c2410c"
    },
    "800": {
      "$type": "color",
      "$value": "#9a3412"
    },
    "900": {
      "$type": "color",
      "$value": "#7c2d12"
    },
    "950": {
      "$type": "color",
      "$value": "#431407"
    }
  },
  "pink": {
    "50": {
      "$type": "color",
      "$value": "#fdf2f8"
    },
    "100": {
      "$type": "color",
      "$value": "#fce7f3"
    },
    "200": {
      "$type": "color",
      "$value": "#fbcfe8"
    },
    "300": {
      "$type": "color",
      "$value": "#f9a8d4"
    },
    "400": {
      "$type": "color",
      "$value": "#f472b6"
    },
    "500": {
      "$type": "color",
      "$value": "#ec4899"
    },
    "600": {
      "$type": "color",
      "$value": "#db2777"
    },
    "700": {
      "$type": "color",
      "$value": "#be185d"
    },
    "800": {
      "$type": "color",
      "$value": "#9d174d"
    },
    "900": {
      "$type": "color",
      "$value": "#831843"
    },
    "950": {
      "$type": "color",
      "$value": "#500724"
    }
  },
  "purple": {
    "50": {
      "$type": "color",
      "$value": "#faf5ff"
    },
    "100": {
      "$type": "color",
      "$value": "#f3e8ff"
    },
    "200": {
      "$type": "color",
      "$value": "#e9d5ff"
    },
    "300": {
      "$type": "color",
      "$value": "#d8b4fe"
    },
    "400": {
      "$type": "color",
      "$value": "#c084fc"
    },
    "500": {
      "$type": "color",
      "$value": "#a855f7"
    },
    "600": {
      "$type": "color",
      "$value": "#9333ea"
    },
    "700": {
      "$type": "color",
      "$value": "#7e22ce"
    },
    "800": {
      "$type": "color",
      "$value": "#6b21a8"
    },
    "900": {
      "$type": "color",
      "$value": "#581c87"
    },
    "950": {
      "$type": "color",
      "$value": "#3b0764"
    }
  },
  "red": {
    "50": {
      "$type": "color",
      "$value": "#fef2f2"
    },
    "100": {
      "$type": "color",
      "$value": "#fee2e2"
    },
    "200": {
      "$type": "color",
      "$value": "#fecaca"
    },
    "300": {
      "$type": "color",
      "$value": "#fca5a5"
    },
    "400": {
      "$type": "color",
      "$value": "#f87171"
    },
    "500": {
      "$type": "color",
      "$value": "#ef4444"
    },
    "600": {
      "$type": "color",
      "$value": "#dc2626"
    },
    "700": {
      "$type": "color",
      "$value": "#b91c1c"
    },
    "800": {
      "$type": "color",
      "$value": "#991b1b"
    },
    "900": {
      "$type": "color",
      "$value": "#7f1d1d"
    },
    "950": {
      "$type": "color",
      "$value": "#450a0a"
    }
  },
  "rose": {
    "50": {
      "$type": "color",
      "$value": "#fff1f2"
    },
    "100": {
      "$type": "color",
      "$value": "#ffe4e6"
    },
    "200": {
      "$type": "color",
      "$value": "#fecdd3"
    },
    "300": {
      "$type": "color",
      "$value": "#fda4af"
    },
    "400": {
      "$type": "color",
      "$value": "#fb7185"
    },
    "500": {
      "$type": "color",
      "$value": "#f43f5e"
    },
    "600": {
      "$type": "color",
      "$value": "#e11d48"
    },
    "700": {
      "$type": "color",
      "$value": "#be123c"
    },
    "800": {
      "$type": "color",
      "$value": "#9f1239"
    },
    "900": {
      "$type": "color",
      "$value": "#881337"
    },
    "950": {
      "$type": "color",
      "$value": "#4c0519"
    }
  },
  "scale": {
    "1": {
      "$type": "number",
      "$value": 16
    },
    "2": {
      "$type": "number",
      "$value": 32
    },
    "3": {
      "$type": "number",
      "$value": 48
    },
    "4": {
      "$type": "number",
      "$value": 64
    },
    "5": {
      "$type": "number",
      "$value": 80
    },
    "18": {
      "$type": "number",
      "$value": 288
    },
    "25": {
      "$type": "number",
      "$value": 400
    },
    "neg-1-5": {
      "$type": "number",
      "$value": -24
    },
    "neg-1-25": {
      "$type": "number",
      "$value": -20
    },
    "neg-1-125": {
      "$type": "number",
      "$value": -18
    },
    "neg-1": {
      "$type": "number",
      "$value": -16
    },
    "neg-0-875": {
      "$type": "number",
      "$value": -14
    },
    "neg-0-75": {
      "$type": "number",
      "$value": -12
    },
    "neg-0-625": {
      "$type": "number",
      "$value": -10
    },
    "neg-0-5": {
      "$type": "number",
      "$value": -8
    },
    "neg-0-375": {
      "$type": "number",
      "$value": -6
    },
    "neg-0-25": {
      "$type": "number",
      "$value": -4
    },
    "0-125": {
      "$type": "number",
      "$value": 2
    },
    "0-25": {
      "$type": "number",
      "$value": 4
    },
    "0-375": {
      "$type": "number",
      "$value": 6
    },
    "0-5": {
      "$type": "number",
      "$value": 8
    },
    "0-625": {
      "$type": "number",
      "$value": 10
    },
    "0-75": {
      "$type": "number",
      "$value": 12
    },
    "0-875": {
      "$type": "number",
      "$value": 14
    },
    "1-125": {
      "$type": "number",
      "$value": 18
    },
    "1-143": {
      "$type": "number",
      "$value": 18.28569984436035
    },
    "1-25": {
      "$type": "number",
      "$value": 20
    },
    "1-5": {
      "$type": "number",
      "$value": 24
    },
    "1-625": {
      "$type": "number",
      "$value": 26
    },
    "1-75": {
      "$type": "number",
      "$value": 28
    },
    "2-25": {
      "$type": "number",
      "$value": 36
    },
    "2-5": {
      "$type": "number",
      "$value": 40
    },
    "2-75": {
      "$type": "number",
      "$value": 44
    },
    "12-5": {
      "$type": "number",
      "$value": 200
    }
  },
  "sky": {
    "50": {
      "$type": "color",
      "$value": "#f0f9ff"
    },
    "100": {
      "$type": "color",
      "$value": "#e0f2fe"
    },
    "200": {
      "$type": "color",
      "$value": "#bae6fd"
    },
    "300": {
      "$type": "color",
      "$value": "#7dd3fc"
    },
    "400": {
      "$type": "color",
      "$value": "#38bdf8"
    },
    "500": {
      "$type": "color",
      "$value": "#0ea5e9"
    },
    "600": {
      "$type": "color",
      "$value": "#0284c7"
    },
    "700": {
      "$type": "color",
      "$value": "#0369a1"
    },
    "800": {
      "$type": "color",
      "$value": "#075985"
    },
    "900": {
      "$type": "color",
      "$value": "#0c4a6e"
    },
    "950": {
      "$type": "color",
      "$value": "#082f49"
    }
  },
  "slate": {
    "50": {
      "$type": "color",
      "$value": "#f8fafc"
    },
    "100": {
      "$type": "color",
      "$value": "#f1f5f9"
    },
    "200": {
      "$type": "color",
      "$value": "#e2e8f0"
    },
    "300": {
      "$type": "color",
      "$value": "#cbd5e1"
    },
    "400": {
      "$type": "color",
      "$value": "#94a3b8"
    },
    "500": {
      "$type": "color",
      "$value": "#64748b"
    },
    "600": {
      "$type": "color",
      "$value": "#475569"
    },
    "700": {
      "$type": "color",
      "$value": "#334155"
    },
    "800": {
      "$type": "color",
      "$value": "#1e293b"
    },
    "900": {
      "$type": "color",
      "$value": "#0f172a"
    },
    "950": {
      "$type": "color",
      "$value": "#020617"
    }
  },
  "stone": {
    "50": {
      "$type": "color",
      "$value": "#fafaf9"
    },
    "100": {
      "$type": "color",
      "$value": "#f5f5f4"
    },
    "200": {
      "$type": "color",
      "$value": "#e7e5e4"
    },
    "300": {
      "$type": "color",
      "$value": "#d6d3d1"
    },
    "400": {
      "$type": "color",
      "$value": "#a8a29e"
    },
    "500": {
      "$type": "color",
      "$value": "#78716c"
    },
    "600": {
      "$type": "color",
      "$value": "#57534e"
    },
    "700": {
      "$type": "color",
      "$value": "#44403c"
    },
    "800": {
      "$type": "color",
      "$value": "#292524"
    },
    "900": {
      "$type": "color",
      "$value": "#1c1917"
    },
    "950": {
      "$type": "color",
      "$value": "#0c0a09"
    }
  },
  "teal": {
    "50": {
      "$type": "color",
      "$value": "#f0fdfa"
    },
    "100": {
      "$type": "color",
      "$value": "#ccfbf1"
    },
    "200": {
      "$type": "color",
      "$value": "#99f6e4"
    },
    "300": {
      "$type": "color",
      "$value": "#5eead4"
    },
    "400": {
      "$type": "color",
      "$value": "#2dd4bf"
    },
    "500": {
      "$type": "color",
      "$value": "#14b8a6"
    },
    "600": {
      "$type": "color",
      "$value": "#0d9488"
    },
    "700": {
      "$type": "color",
      "$value": "#0f766e"
    },
    "800": {
      "$type": "color",
      "$value": "#115e59"
    },
    "900": {
      "$type": "color",
      "$value": "#134e4a"
    },
    "950": {
      "$type": "color",
      "$value": "#042f2e"
    }
  },
  "violet": {
    "50": {
      "$type": "color",
      "$value": "#f5f3ff"
    },
    "100": {
      "$type": "color",
      "$value": "#ede9fe"
    },
    "200": {
      "$type": "color",
      "$value": "#ddd6fe"
    },
    "300": {
      "$type": "color",
      "$value": "#c4b5fd"
    },
    "400": {
      "$type": "color",
      "$value": "#a78bfa"
    },
    "500": {
      "$type": "color",
      "$value": "#8b5cf6"
    },
    "600": {
      "$type": "color",
      "$value": "#7c3aed"
    },
    "700": {
      "$type": "color",
      "$value": "#6d28d9"
    },
    "800": {
      "$type": "color",
      "$value": "#5b21b6"
    },
    "900": {
      "$type": "color",
      "$value": "#4c1d95"
    },
    "950": {
      "$type": "color",
      "$value": "#2e1065"
    }
  },
  "yellow": {
    "50": {
      "$type": "color",
      "$value": "#fefce8"
    },
    "100": {
      "$type": "color",
      "$value": "#fef9c3"
    },
    "200": {
      "$type": "color",
      "$value": "#fef08a"
    },
    "300": {
      "$type": "color",
      "$value": "#fde047"
    },
    "400": {
      "$type": "color",
      "$value": "#facc15"
    },
    "500": {
      "$type": "color",
      "$value": "#eab308"
    },
    "600": {
      "$type": "color",
      "$value": "#ca8a04"
    },
    "700": {
      "$type": "color",
      "$value": "#a16207"
    },
    "800": {
      "$type": "color",
      "$value": "#854d0e"
    },
    "900": {
      "$type": "color",
      "$value": "#713f12"
    },
    "950": {
      "$type": "color",
      "$value": "#422006"
    }
  },
  "zinc": {
    "50": {
      "$type": "color",
      "$value": "#fafafa"
    },
    "100": {
      "$type": "color",
      "$value": "#f4f4f5"
    },
    "200": {
      "$type": "color",
      "$value": "#e4e4e7"
    },
    "300": {
      "$type": "color",
      "$value": "#d4d4d8"
    },
    "400": {
      "$type": "color",
      "$value": "#a1a1aa"
    },
    "500": {
      "$type": "color",
      "$value": "#71717a"
    },
    "600": {
      "$type": "color",
      "$value": "#52525b"
    },
    "700": {
      "$type": "color",
      "$value": "#3f3f46"
    },
    "800": {
      "$type": "color",
      "$value": "#27272a"
    },
    "900": {
      "$type": "color",
      "$value": "#18181b"
    },
    "950": {
      "$type": "color",
      "$value": "#09090b"
    }
  }
}
